
const Parallax = () => {
    return <div className="my-parallax"></div>;
}

export default Parallax;
